import { getElement, hideElement, setOpacity, showElement } from './dom'

export const showImageElement = () => {
  const videoElem = getElement('video-content')
  const imageElem = getElement('image-content')
  const mediaElement = getElement('mediaElement')

  if (!imageElem) {
    return
  }

  setOpacity(mediaElement, 0)
  hideElement(videoElem)
  showElement(imageElem)
  return imageElem
}

export const showVideoElement = () => {
  const videoElem = getElement('video-content')
  const imageElem = getElement('image-content')
  const mediaElement = getElement('mediaElement')

  if (!videoElem) {
    return
  }

  setOpacity(mediaElement, 0)
  hideElement(imageElem)
  showElement(videoElem)
  return videoElem
}

export const showVastElement = () => {
  const videoElem = getElement('video-content')
  const imageElem = getElement('image-content')
  const mediaElement = getElement('mediaElement')

  if (!mediaElement) {
    return
  }

  hideElement(videoElem)
  hideElement(imageElem)
  setOpacity(mediaElement, 1)
  showElement(mediaElement)
  return mediaElement
}

export const showLoadingSpinner = () => {
  const loaderContainer = getElement('loading-container')
  if (loaderContainer) {
    loaderContainer.style.display = 'flex'
    setOpacity(loaderContainer, 1)
  }
}

export const hideLoadingSpinner = () => {
  const loaderContainer = getElement('loading-container')
  if (loaderContainer) {
    setOpacity(loaderContainer, 0)
    loaderContainer.style.display = 'none'
  }
}
